import React from 'react'

import Table from '../../../../../../UI/Table/Table'
import { Add, Edit, Delete } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import { memo } from 'react'

const dataTable = ({
    translate,
    recordData,
    structureName,
    structureType,
    addButtonClicked,
    editButtonClicked,
    deleteButtonClicked,
    addDisabled,
    editDisabled,
    deleteDisabled,
    loading
}) => {
    const competencyScoreTable = [
        {
            field: 'structure_id', title: translate('structureName'), type: 'string', width: '20%',
            render: rowData => {
                return (
                    <div
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: 550
                        }}>
                        {rowData.structure?.structure_name ?? null}
                    </div>
                )
            }
        },
        {
            field: 'score', title: translate('score'), type: 'string', width: '10%', align: 'right',
            render: rowData => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'left',
                            marginLeft: '10px'
                        }}>
                        {rowData.score === '.00' ? '0' : parseInt(rowData.score)}
                    </div>
                )
            }
        },
        {
            field: 'score_name', title: translate('competencyScore'), type: 'string', width: '60%',
            render: rowData => {
                return (
                    <div
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: 550
                        }}>
                        {rowData.score_name}
                    </div>
                )
            }
        }
    ]

    const rowActions = [
        {
            icon: () => <Add />,
            tooltip: translate('add'),
            onClick: addButtonClicked,
            isFreeAction: true,
            disabled: addDisabled
        },
        {
            icon: () => <Edit fontSize={'small'} />,
            tooltip: translate('edit'),
            onClick: (event, selectedRecord) => editButtonClicked(selectedRecord.cs_id),
            disabled: editDisabled
        },
        {
            icon: () => <Delete fontSize={'small'} />,
            tooltip: translate('delete'),
            onClick: (event, selectedRecord) => deleteButtonClicked(selectedRecord.cs_id),
            disabled: deleteDisabled
        }
    ]

    // let tableStructure = tableStructures[structureType] || quantityTableStructure
    return (
        <Table
            alignLeft
            paginationDisabled={true}
            rowActions={rowActions}
            title={structureName}
            recordData={recordData}
            structure={competencyScoreTable}
            loading={loading}
        />
    )
}

export default withTranslate(memo(dataTable))
